var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            width: "400px",
            title: "Edit HCP",
            visible: _vm.dialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            closed: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name", label: "Name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input name",
                      maxlength: "10",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "city", label: "City" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input city",
                      maxlength: "25",
                    },
                    model: {
                      value: _vm.form.city,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "city", $$v)
                      },
                      expression: "form.city",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "hospital", label: "Hospital / Institution" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input hospital / institution",
                      maxlength: "25",
                    },
                    model: {
                      value: _vm.form.hospital,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hospital", $$v)
                      },
                      expression: "form.hospital",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "department", label: "Department" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input department",
                      maxlength: "25",
                    },
                    model: {
                      value: _vm.form.department,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "department", $$v)
                      },
                      expression: "form.department",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.loading ? "Saving" : "Save") + " ")]
              ),
              _c("el-button", { on: { click: _vm.onClosed } }, [
                _vm._v("Cancel"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }